<template>
  <!-- Pop up for based on payout -->
  <vs-popup
    :active.sync="shouldDisplay"
    v-if="shouldDisplay"
    vs-lg="12"
    vs-md="12"
    @click="closePopup()"
    classContent="payout-details-modal-wrapper"
    button-close-hidden>
    <header>
      <h1>Fiat Payout Details</h1>
      <button @click="closePopup()">X</button>
    </header>
    <dl>
      <div>
        <dt>Fiat Payout Reference</dt>
        <dd>{{ fiatPayoutDetail.reference_number }}</dd>
      </div>
      <div>
        <dt>Status</dt>
        <dd>
          <Tag :class="fiatPayoutDetail.status">{{ fiatPayoutDetail.status }}</Tag>
        </dd>
      </div>
      <div>
        <dt>Sending amount</dt>
        <dd>
          {{ fiatPayoutDetail.sending_currency }}
          {{ formatFiatPrice(fiatPayoutDetail.sending_amount) }}
        </dd>
      </div>
      <div>
        <dt>Receiving amount</dt>
        <dd>
          {{ fiatPayoutDetail.receiving_currency }}
          {{ formatFiatPrice(fiatPayoutDetail.receiving_amount) }}
        </dd>
      </div>
      <div>
        <dt>Exchange rate</dt>
        <dd>
          {{
          `1 ${fiatPayoutDetail.sending_currency} = ${formatExchangeRateValue(fiatPayoutDetail.exchange_rate)} ${fiatPayoutDetail.receiving_currency}`
          }}
        </dd>
      </div>
      <div>
        <dt>Fees</dt>
        <dd>
          {{
          `${fiatPayoutDetail.fee_currency} ${formatFiatPrice(fiatPayoutDetail.fee)}`
          }}
        </dd>
        <dd v-if="fiatPayoutDetail.intermediary_bank_fee">Including Intermediary bank fee of {{ `${fiatPayoutDetail.intermediary_bank_fee} ${fiatPayoutDetail.fee_currency}`}}</dd>
      </div>
      <div>
        <dt>ID</dt>
        <dd>{{ fiatPayoutDetail.id }}</dd>
      </div>
      <div v-if="fiatPayoutDetail.external_id">
        <dt>External ID</dt>
        <dd>{{ fiatPayoutDetail.external_id }}</dd>
      </div>
      <div>
        <dt>Creation Date</dt>
        <dd>
          {{ formatToLocalDate(fiatPayoutDetail.created_at) }},
          {{ formatToLocalTime(fiatPayoutDetail.created_at) }}
        </dd>
      </div>
      <div>
        <dt>Last status update</dt>
        <dd>
          {{ formatToLocalDate(fiatPayoutDetail.updated_at) }},
          {{ formatToLocalTime(fiatPayoutDetail.updated_at) }}
        </dd>
      </div>
      <div>
        <dt>Transfer type</dt>
        <dd>
          {{
          fiatPayoutDetail.sending_currency_info
          ? toTransferTypeLabel(
          fiatPayoutDetail.sending_currency_info.type,
          fiatPayoutDetail.receiving_currency_info.type
          )
          : ' '
          }}
        </dd>
      </div>
      <div>
        <dt>Mode</dt>
        <dd>{{ fiatPayoutDetail.mode }} exactly</dd>
      </div>
      <div>
        <dt>Service</dt>
        <dd>
          {{
          toTransferServiceLabel(fiatPayoutDetail.destination_account.type)
          }}
        </dd>
      </div>
      <div>
        <dt>Source of funds</dt>
        <dd class="capitalized">
          {{ formatSnake(fiatPayoutDetail.source_of_funds) }}
        </dd>
      </div>
      <div>
        <dt>Purpose</dt>
        <dd class="capitalized">
          {{ formatSnake(fiatPayoutDetail.purpose_of_remittance) }}
        </dd>
      </div>
    </dl>
    <section>
      <h2>Sender's information</h2>
      <dl>
        <div>
          <dt>Sender's name</dt>
          <dd>
            {{
            fiatPayoutDetail.sender_info
            ? fiatPayoutDetail.sender_info.sender_name
            : ''
            }}
          </dd>
        </div>
        <div>
          <dt>Sending Country</dt>
          <dd>
            {{
            fiatPayoutDetail.source_country_info
            ? fiatPayoutDetail.source_country_info.name
            : ''
            }}
          </dd>
        </div>
      </dl>
    </section>
    <section>
      <h2>Recipient's information</h2>
      <dl>
        <div>
          <dt>Recipient's name</dt>
          <dd>
            {{
            fiatPayoutDetail.destination_account && fiatPayoutDetail.destination_account.account
            ? fiatPayoutDetail.destination_account.account.account_name
            : ''
            }}
          </dd>
        </div>
        <div>
          <dt>Receiving Country</dt>
          <dd>
            {{
            fiatPayoutDetail.destination_account &&
            fiatPayoutDetail.destination_account.destination_country_info
            ? fiatPayoutDetail.destination_account.destination_country_info
            .name
            : ''
            }}
          </dd>
        </div>
      </dl>
    </section>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import Tag from '../../atoms/Tag.vue';

export default {
  name: 'PayoutDetailsPopup',
  props: ['fiatPayoutDetail', 'shouldDisplay'],
  components: {
    Tag
  },
  data() {
    return {
      debugConsole: false,
    };
  },
  mounted() {
    window.addEventListener('keyup', this.closePopupEscKey); // Add 'keyup' event to the popup
    window.addEventListener('keyup', this.closePopupEscKeyAddress);
  },
  updated() {
    if (!this.shouldDisplay) {
      // to close the popup properly of user clicks beside it to close
      this.closePopup();
    }
  },
  computed: {
    ...mapGetters([]),
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.closePopupEscKey); // Remove 'keyup' event to the popup
    window.removeEventListener('keyup', this.closePopupEscKeyAddress);
  },
  methods: {
    closePopup() {
      this.$emit('close-details-modal');
    },
    closePopupEscKey(e) {
      //Press 'Esc' to close the popup
      if (e.keyCode === 27) {
        this.closePopup();
      }
    },
    closePopupEscKeyAddress(e) {
      //Press 'Esc' to close the popup for Address popup
      if (e.keyCode === 27) {
        this.closePopup();
      }
    },
    formatSnake(str) {
      const s = str.split('_');
      return s.join(' ').toLowerCase();
    }
  },
};
</script>

<style lang="scss">
.payout-details-modal-wrapper {
  padding: 24px 24px 24px 40px !important;

  header {
    display: flex;
    margin-bottom: 12px;

    button {
      height: 32px;
      width: 32px;
      border: none;
      border-radius: 10px;
      margin-left: auto;
      transition: ease-in-out 0.2s;

      &:hover {
        background-color: rgb(174, 174, 174);
        cursor: pointer;
      }

      &.cancel {
        width: auto;
        color: white;
        background-color: #ca2828;
        border-radius: 6px;
        padding: 0 10px;
        margin-left: 24px;

        &:hover {
          background-color: #8c2222;
        }
      }

      &.email {
        width: auto;
        color: white;
        background-color: rgb(7, 85, 147);
        border-radius: 6px;
        padding: 0 10px;
        margin-left: 12px;

        &:hover {
          cursor: pointer;
          background-color: rgb(5, 59, 102);
        }
      }
    }
  }

  dl {
    display: flex;
    flex-wrap: wrap;

    .capitalized {
      text-transform: capitalize;
    }

    &>div {
      width: 50%;
      margin-bottom: 16px;
      padding-right: 12px;
      min-width: 300px;
      max-width: 380px;

      dt {
        font-weight: 700;
        color: #505050;
        text-transform: capitalize;
      }

      dd {
        line-break: anywhere;
      }

      &.remarks {
        width: 100%;
      }

      &.order-id {
        width: 100%;
      }
    }
  }

  h2 {
    margin-bottom: 12px;
  }

  .payment-details {
    margin-top: 24px;
  }
}

/* CUSTOMISED SCROLLBAR */
/*===========================*/
.vs-popup--content::-webkit-scrollbar {
  width: 10px;
}

.vs-popup--content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
</style>
